<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="modal-body">
  {{ message }}
</div>
<div class="modal-footer d-flex justify-content-between">
  <button type="button" class="btn btn-danger" (click)="decline()">{{ btnCancelText }}</button>
  <button type="button" class="btn btn-success" (click)="accept()">{{ btnOkText }}</button>
</div>
